import { activeApplicationStatuses, normalizeApplicationStatus } from './applicationStatus';

type Status = typeof activeApplicationStatuses[number];
const nextSteps: Record<Status, string | null> = {
  DRAFT: 'Complete application',
  SUBMITTED: 'Under review',
  APPROVED: 'Meet conditions',
  REJECTED: 'View decision',
  DEFERRED: 'Confirm new intake',
  WITHDRAWN: null,
  TUITION_PAYMENT_STAGE: 'Pay tuition',
  PAID: 'Submit visa application',
  VISA_APPLICATION: 'Complete visa application',
  VISA_APPROVED: 'Prepare for enrolment',
  ENROLLED: null,
};

export type ApplicationGuidance =
  | { kind: 'action'; text: string }
  | { kind: 'no-action'; text: '—' }
  | { kind: 'unknown'; text: null };

/** Current application statuses only; never use for historical events. */
export function applicationNextStep(status: string): ApplicationGuidance {
  const canonical = normalizeApplicationStatus(status);
  if (!Object.prototype.hasOwnProperty.call(nextSteps, canonical)) return { kind: 'unknown', text: null };
  const text = nextSteps[canonical as Status];
  return text === null ? { kind: 'no-action', text: '—' } : { kind: 'action', text };
}
